import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import '../App.css';

function Login() {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await api.post('/auth/login', { password });
      const { token } = res.data || {};
      if (token) {
        localStorage.setItem('token', token);
        navigate('/admin', { replace: true });
      } else {
        setError('Unexpected response');
      }
    } catch (err) {
      setError('Invalid password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-container" style={{ minHeight: '100vh' }}>
      <div className="admin-header">
        <h1>ADMIN LOGIN</h1>
        <p>Enter password to access console</p>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit" className="btn" disabled={loading}>
          {loading ? 'Logging in...' : 'Login'}
        </button>
        {error && (
          <p style={{ color: '#ff6b6b', marginTop: 10, fontFamily: 'Special Elite, monospace' }}>
            {error}
          </p>
        )}
      </form>
    </div>
  );
}

export default Login;


